import TablesNav from "./tablesNav/tablesNav";
import Menu from "./menu/menu";
import BuyInMenu from "./buyInMenu";

export default class Header {
  constructor(scene) {
    this.scene = scene;
    this.tablesNav = new TablesNav(scene);
    this.menu = new Menu(scene);
    this.buyInMenu = new BuyInMenu(scene);
  }
  positionControls(width, height, tableWidth, tableHeight) {
    this.menu.positionControls(tableWidth, tableHeight);
    this.tablesNav.positionControls(width, height, tableWidth, tableHeight);
    this.buyInMenu.positionControls(width, height);
  }
  reposition(width, height, tableWidth, tableHeight) {
    this.menu.reposition(tableWidth, tableHeight);
    this.tablesNav.reposition(width, height, tableWidth, tableHeight);
    this.buyInMenu.reposition(width, height);
  }
}
